export const BREACHES_TYPES = {
  PASSWORD: 'password',
  HASHED: 'hashed',
  NOT_AVAILABLE: 'not_available',
} as const

export const BREACHES_SEVERITIES = {
  CRITICAL: 'critical',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
  UNKNOWN: 'unknown',
} as const

export const BREACH_REVIEW_FILTER = {
  ALL: 'all',
  PENDING: 'pending',
  REVIEWED: 'reviewed',
} as const

export type IBreachReviewFilter = (typeof BREACH_REVIEW_FILTER)[keyof typeof BREACH_REVIEW_FILTER]

export const BREACHES_EXPORT_FILENAME = 'easm-breaches.csv'
